// eslint-disable-next-line import/prefer-default-export
export const pageTypes = {
  informational: {
    section: "navigation",
    showLogoWithLink: true,
    disableSearch: false,
    customComponent: false,
    exclusiveOperator: false,
    navMenu: "main_menu",
    showNavMenu: true,
    disablePopup: true,
  },
  responsible_gambling_guide: {
    disableFooter: true,
    section: "rg_navigation",
    showLogoWithLink: false,
    disableSearch: false,
    customComponent: false,
    exclusiveOperator: false,
    navMenu: "rg_menu",
    showNavMenu: true,
    disablePopup: true,
  },
  ppc: {
    showNavMenu: false,
    showLogoWithLink: false,
    disablePopup: true,
  },
  sports: {
    disablePopup: true,
  },
  default: {
    section: "navigation",
    showLogoWithLink: true,
    disableSearch: false,
    showNotification: true,
    customComponent: true,
    exclusiveOperator: true,
    navMenu: "main_menu",
    showNavMenu: true,
    disablePopup: false,
  },
};

export const layout = {
  operator_review: {
    footerNavigation: false,
  },
  homepage: {
    footerNavigation: false,
  }
};
